// extracted by mini-css-extract-plugin
module.exports = {"count":"Textarea_count__1Ni-D"};